export const GET_PLAYER_BALANCE = "GET_PLAYER_BALANCE"
export const GET_PLAYER_BALANCE_SUCCESS = "GET_PLAYER_BALANCE_SUCCESS"

